import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { REACT_APP_API_URL } from "../../../../../env";

import { setAvailabilityData } from "../../../../../Redux/slice/features/availabilitySlice";
import axios from "axios";

const getRoomTypeId = (room) =>
  Number(room?.RoomConfigID ?? room?.HotelRoomConfigID ?? room?.RoomTypeId);

const findAvailabilityRoom = (rooms, roomTypeId) => {
  const targetRoomTypeId = Number(roomTypeId);
  if (!targetRoomTypeId || !Array.isArray(rooms)) return null;

  return rooms.find((room) => getRoomTypeId(room) === targetRoomTypeId);
};

const getNumericValue = (value) => {
  if (value === undefined || value === null) return null;

  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

const HotelBlockingForm = () => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState("");
  const [hotels, setHotels] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [selectedRoomType, setSelectedRoomType] = useState("");
  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");
  const [numberOfRooms, setNumberOfRooms] = useState("");
  const [totalBlockedRooms, setTotalBlockedRooms] = useState("");
  const [newBlockRoom, setNewBlockRoom] = useState("");
  const [Remarks, setRemarks] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [dateError, setDateError] = useState("");
  const [totalRooms, setTotalRooms] = useState(0);
  const [availableRooms, setAvailableRooms] = useState(0);
  const [selectedRoomName, setSelectedRoomName] = useState("");
  const [blockedRoomsInfo, setBlockedRoomsInfo] = useState({
    count: 0,
    fromDate: "",
    toDate: "",
  });
  const [availabilityRooms, setAvailabilityRooms] = useState([]);

  const blockedDays = useMemo(() => {
    if (!checkInDate || !checkOutDate) return "--";

    const start = new Date(checkInDate);
    const end = new Date(checkOutDate);

    return (
      Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1
    );
  }, [checkInDate, checkOutDate]);

  const dispatch = useDispatch();

  const todayStr = new Date().toISOString().split("T")[0];

  const applySelectedAvailability = useCallback((rooms, roomTypeId = selectedRoomType) => {
    const matchedRoom = findAvailabilityRoom(rooms, roomTypeId);
    const availableRoomCount = getNumericValue(matchedRoom?.AvailableRooms);

    if (availableRoomCount === null) return false;

    setAvailableRooms(availableRoomCount);

    const totalRoomCount = getNumericValue(
      matchedRoom?.TotalRooms ?? matchedRoom?.NoOfRooms,
    );
    if (totalRoomCount !== null) {
      setTotalRooms(totalRoomCount);
    }

    return true;
  }, [selectedRoomType]);

  const handleCheckInDateChange = async (e) => {

    const value = e.target.value;
    setCheckInDate(value);

    if (!value) {
      setAvailableRooms(0);
      setAvailabilityRooms([]);
      setTotalBlockedRooms("");
      return;
    }

    if (value && value < todayStr) {
      setDateError("Check-In date cannot be before today.");
      setAvailableRooms(0);
      setAvailabilityRooms([]);
      setTotalBlockedRooms("");
      setNewBlockRoom("");
    } else if (checkOutDate && value > checkOutDate) {
      setDateError("Check-In date cannot be after Check-Out date.");
      setAvailableRooms(0);
      setAvailabilityRooms([]);
      setTotalBlockedRooms("");
      setNewBlockRoom("");
    } else {
      setDateError("");
      setTotalBlockedRooms("");
      setNewBlockRoom("");

      if (selectedHotel && checkOutDate && value <= checkOutDate) {
        await fetchRoomConfigs(selectedHotel);

        if (selectedRoomType) {
          try {
            const response = await axios.post(
              `${REACT_APP_API_URL}api/dashboard/admin/total-rooms`,
              {
                P_INTPROPERTYID: selectedHotel,
                P_INTROOMTYPEID: selectedRoomType,
                P_DTFROMDATE: value,
                P_DTTODATE: checkOutDate,
              },
            );


            const parsed = parseRoomApiData(response.data.data);
            setTotalRooms(parsed.noOfRooms);
            console.log("Calling RB fetch (check-in change):", {
              hotelId: selectedHotel,
              roomTypeId: selectedRoomType,
              fromDate: value,
              toDate: checkOutDate,
            });
            await fetchRoomBlocking(
              selectedHotel,
              selectedRoomType,
              value,
              checkOutDate,
            );
            await handleCheckAvailability(null, selectedHotel, selectedRoomType, {
              checkInDate: value,
              checkOutDate,
            });
          } catch (error) {
            console.error("Error updating room availability:", error);
          }
        }
      }
    }
  };

  const handleCheckOutDateChange = async (e) => {

    const value = e.target.value;
    setCheckOutDate(value);

    if (!value) {
      setAvailableRooms(0);
      setAvailabilityRooms([]);
      setTotalBlockedRooms("");
      setNewBlockRoom("");
      return;
    }

    if (checkInDate && value && value < checkInDate) {
      setDateError("Check-Out date cannot be before Check-In date.");
      setAvailableRooms(0);
      setAvailabilityRooms([]);
      setTotalBlockedRooms("");
      setNewBlockRoom("");
    } else {
      setDateError("");
      setTotalBlockedRooms("");
      setNewBlockRoom("");

      if (selectedHotel && checkInDate && value >= checkInDate) {
        await fetchRoomConfigs(selectedHotel);

        if (selectedRoomType) {
          try {
            const response = await axios.post(
              `${REACT_APP_API_URL}api/dashboard/admin/total-rooms`,
              {
                P_INTPROPERTYID: selectedHotel,
                P_INTROOMTYPEID: selectedRoomType,
                P_DTFROMDATE: checkInDate,
                P_DTTODATE: value,
              },
            );


            const parsed = parseRoomApiData(response.data.data);
            setTotalRooms(parsed.noOfRooms);
            console.log("Calling RB fetch (check-out change):", {
              hotelId: selectedHotel,
              roomTypeId: selectedRoomType,
              fromDate: checkInDate,
              toDate: value,
            });
            await fetchRoomBlocking(
              selectedHotel,
              selectedRoomType,
              checkInDate,
              value,
            );
            await handleCheckAvailability(null, selectedHotel, selectedRoomType, {
              checkInDate,
              checkOutDate: value,
            });
          } catch (error) {
            console.error("Error updating room availability:", error);
            setTotalBlockedRooms("");
          }
        }
      }
    }
  };

  const getAvailabilityDates = (checkIn, checkOut) => {
    if (!checkIn || !checkOut) {
      return {
        checkInDate: checkIn,
        checkOutDate: checkOut,
      };
    }

    // Room Blocking uses an inclusive end date.
    // Availability API expects an exclusive checkout date.
    const nextDay = new Date(checkOut);
    nextDay.setDate(nextDay.getDate() + 1);

    return {
      checkInDate: checkIn,
      checkOutDate: nextDay.toISOString().split("T")[0],
    };
  };

  const handleCheckAvailability = async (
    e,
    hotelId = null,
    roomTypeId = selectedRoomType,
    dates = {},
  ) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const targetHotel = hotelId || selectedHotel;
    const requestedCheckIn = dates.checkInDate || checkInDate;
    const requestedCheckOut = dates.checkOutDate || checkOutDate;

    const {
      checkInDate: targetCheckInDate,
      checkOutDate: targetCheckOutDate,
    } = getAvailabilityDates(requestedCheckIn, requestedCheckOut);

    if (!targetHotel || !targetCheckInDate || !targetCheckOutDate) {
      console.log("Missing required data for availability check");
      return;
    }

    localStorage.setItem("checkInDate", targetCheckInDate);
    localStorage.setItem("checkOutDate", targetCheckOutDate);

    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}api/checkAvailabilityAdmin/${targetHotel}`,
        {
          check_in_date: targetCheckInDate,
          check_out_date: targetCheckOutDate,
        },
      );
      if (response.status === 200) {
        const availability = Array.isArray(response.data.data)
          ? response.data.data
          : [];
        const roomTariff = Array.isArray(response.data.roomConfigs)
          ? response.data.roomConfigs
          : [];

        const mergedRooms = availability.map((room) => {
          const matchingTariff = roomTariff.find(
            (tariff) => Number(tariff.RoomTypeId) === Number(room.RoomConfigID),
          );
          return {
            ...(matchingTariff || {}),
            ...room,
            HotelRoomConfigID: room.RoomConfigID,
          };
        });

        dispatch(
          setAvailabilityData({
            rooms: mergedRooms,
            check_in_date: targetCheckInDate,
            check_out_date: targetCheckOutDate,
          }),
        );
        setAvailabilityRooms(mergedRooms);
        applySelectedAvailability(mergedRooms, roomTypeId);
      }
    } catch (error) {
      console.error("Error checking availability:", error);
    }
  };
  const handleNumberOfRoomsChange = (e) => {
    let value = parseInt(e.target.value, 10);
    if (value < 1) {
      value = 1;
    }
    if (totalRooms > 0 && value > totalRooms) {
      value = totalRooms;
    }
    setNumberOfRooms(value);
  };

  const fetchRoomConfigs = useCallback(async (hotelId) => {
    if (!hotelId) return;

    console.log("Fetching room config for hotelId:", hotelId);
    try {
      const roomConfigResponse = await axios.post(
        `${REACT_APP_API_URL}api/dashboard/admin/get-room-config`,
        {
          P_INTPROPERTYID: hotelId,
          P_CHARACTION: "All",
        },
      );

      const fetchedRoomTypes = roomConfigResponse.data.data || [];
      const activeRoomTypes = fetchedRoomTypes.filter(
        (room) => room.Status === 1,
      );

      console.log("Active room types:", activeRoomTypes);

      const mappedRoomTypes = activeRoomTypes.map((room) => ({
        ...room,
        RoomConfigID: room.RoomConfigID || room.HotelRoomConfigID,
        RoomType: room.RoomType || room.RoomConfigName,
      }));

      setRoomTypes(mappedRoomTypes);

      if (selectedRoomType) {
        const response = await axios.post(
          `${REACT_APP_API_URL}api/dashboard/admin/total-rooms`,
          {
            P_INTPROPERTYID: hotelId,
            P_INTROOMTYPEID: selectedRoomType,
          },
        );

        if (response.data && response.data.data !== undefined) {
          console.log("Total Rooms Response:", response.data);
          const parsed = parseRoomApiData(response.data.data);
          setTotalRooms(parsed.noOfRooms);
        }
      }
    } catch (error) {
      console.error("Error fetching room configurations:", error);
    }
  }, [selectedRoomType]);

  const fetchRoomBlocking = async (hotelId, roomTypeId, fromDate, toDate) => {
    if (
      hotelId == null ||
      roomTypeId == null ||
      fromDate == null ||
      toDate == null
    )
      return null;

    try {
      const payload = {
        P_INTPROPERTYID: hotelId,
        P_INTROOMTYPEID: roomTypeId,
        P_CHARACTION: "RB",
        P_DTFROMDATE: fromDate,
        P_DTTODATE: toDate,
      };

      const response = await axios.post(
        `${REACT_APP_API_URL}api/dashboard/admin/get-block-room-details`,
        payload,
      );

      console.log("RB response:", response.data);

      const data = response.data?.data;

      // Reset when no blocked rooms exist for the selected date range
      if (!data || (Array.isArray(data) && data.length === 0)) {
        setBlockedRoomsInfo({
          count: 0,
          fromDate,
          toDate,
        });

        setTotalBlockedRooms("");

        return response.data;
      }

      const source = Array.isArray(data) ? data[0] : data;

      if (source?.NoOfRooms !== undefined) {
        setTotalRooms(source.NoOfRooms);
      }

      const blocked = Number(source?.BlockRooms || 0);

      setBlockedRoomsInfo({
        count: blocked,
        fromDate,
        toDate,
      });

      setTotalBlockedRooms("");

      return response.data;
    } catch (error) {
      console.error("Error fetching room blocking (RB):", error);
      return null;
    }
  };

  const parseRoomApiData = (data) => {
    if (data == null) return { noOfRooms: 0, availableRooms: 0 };

    if (typeof data === "number") {
      return { noOfRooms: data, availableRooms: 0 };
    }

    const src = Array.isArray(data) ? data[0] : data;
    if (typeof src === "number") return { noOfRooms: src, availableRooms: 0 };
    if (typeof src === "object" && src !== null) {
      return {
        noOfRooms: src.NoOfRooms ?? src.NoOfRooms ?? 0,
        availableRooms: src.AvailableRooms ?? 0,
      };
    }
    return { noOfRooms: 0, availableRooms: 0 };
  };

  const fetchRoomDetails = useCallback(async (
    hotelId,
    roomTypeId,
    fromDate = null,
    toDate = null,
  ) => {
    try {
      const payload = {
        P_INTPROPERTYID: hotelId,
        P_INTROOMTYPEID: roomTypeId,
      };

      if (fromDate && toDate) {
        payload.P_DTFROMDATE = fromDate;
        payload.P_DTTODATE = toDate;
      }

      const response = await axios.post(
        `${REACT_APP_API_URL}api/dashboard/admin/total-rooms`,
        payload,
      );
      console.log("Room Details:", response.data.data);
      const parsed = parseRoomApiData(response.data.data);
      setTotalRooms(parsed.noOfRooms);
      applySelectedAvailability(availabilityRooms, roomTypeId);
    } catch (error) {
      console.error("Error fetching room details:", error);
    }
  }, [availabilityRooms, applySelectedAvailability]);

  const handleHotelChange = async (e) => {
    const hotelId = parseInt(e.target.value);
    setSelectedHotel(hotelId);

    setSelectedRoomType("");
    setTotalRooms(0);
    setAvailableRooms(0);
    setAvailabilityRooms([]);
    setSelectedRoomName("");
    setNumberOfRooms("");
    setTotalBlockedRooms("");

    if (hotelId) {
      console.log("Selected hotelId:", hotelId);

      if (checkInDate && checkOutDate) {
        handleCheckAvailability(null, hotelId);
      }
    } else {
      setRoomTypes([]);
    }
  };

  useEffect(() => {
    if (selectedHotel) {
      fetchRoomConfigs(selectedHotel);
    }
  }, [selectedHotel, fetchRoomConfigs]);

  const handleRoomTypeChange = async (e) => {

    const value = e.target.value;
    if (!value) {
      setSelectedRoomType("");
      setTotalRooms(0);
      setAvailableRooms(0);
      setNumberOfRooms("");
      setTotalBlockedRooms("");
      return;
    }

    const roomTypeId = Number(value);
    const selectedRoom = roomTypes.find(
      (room) =>
        room.RoomConfigID === roomTypeId ||
        room.HotelRoomConfigID === roomTypeId,
    );

    if (!selectedRoom) {
      console.error("Selected room not found in roomTypes");
      return;
    }

    console.log("Selected Room:", selectedRoom);
    setSelectedRoomType(roomTypeId);
    setNumberOfRooms("");
    setTotalBlockedRooms("");
    setSelectedRoomName(selectedRoom.RoomType || "");
    applySelectedAvailability(availabilityRooms, roomTypeId);

    try {
      console.log(
        "Fetching total rooms for hotel:",
        selectedHotel,
        "roomType:",
        roomTypeId,
      );
      const response = await axios.post(
        `${REACT_APP_API_URL}api/dashboard/admin/total-rooms`,
        {
          P_INTPROPERTYID: selectedHotel,
          P_INTROOMTYPEID: roomTypeId,
        },
      );

      if (response.data && response.data.data !== undefined) {
        console.log("Total Rooms Response:", response.data);
        setTotalRooms(response.data.data);
      } else {
        console.error("Invalid response format:", response);
      }

      if (checkInDate && checkOutDate) {
        const availabilityResponse = await axios.post(
          `${REACT_APP_API_URL}api/dashboard/admin/total-rooms`,
          {
            P_INTPROPERTYID: selectedHotel,
            P_INTROOMTYPEID: roomTypeId,
            P_DTFROMDATE: checkInDate,
            P_DTTODATE: checkOutDate,
          },
        );

        if (
          availabilityResponse.data &&
          availabilityResponse.data.data !== undefined
        ) {
          console.log("Date-specific Availability:", availabilityResponse.data);

          const parsed = parseRoomApiData(availabilityResponse.data.data);
          setTotalRooms(parsed.noOfRooms);

          await fetchRoomBlocking(
            selectedHotel,
            roomTypeId,
            checkInDate,
            checkOutDate,
          );
          await handleCheckAvailability(null, selectedHotel, roomTypeId);
        }
      }
    } catch (error) {
      console.error("Error fetching room details:", error);
    }
  };

  useEffect(() => {
    const fetchHotelData = async () => {
      try {
        const response = await axios.get(
          `${REACT_APP_API_URL}api/room-tariff/get-hotels`,
        );
        console.log("response", response);
        setHotels(response.data.data);
      } catch (error) {
        console.error("Error fetching hotel data:", error);
      }
    };
    fetchHotelData();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!checkInDate || !checkOutDate) {
      setDateError("Both Check-In and Check-Out dates are required.");
      return;
    }
    if (checkInDate < todayStr) {
      setDateError("Check-In date cannot be before today.");
      return;
    }
    if (checkOutDate < checkInDate) {
      setDateError("Check-Out date cannot be before Check-In date.");
      return;
    }
    if (
      totalBlockedRooms === "" ||
      Number(totalBlockedRooms) < 0 ||
      Number(totalBlockedRooms) > totalRooms
    ) {
      alert("Please enter a valid total blocked rooms.");
      return;
    }
    setDateError("");
    setShowConfirmModal(true);
  };

  const confirmBlocking = async () => {
    setShowConfirmModal(false);

    let hotelId = parseInt(selectedHotel);
    const formData = new FormData();

    formData.append("BlockFrom", checkInDate);
    formData.append("BlockTo", checkOutDate);
    formData.append("BlockRooms", totalBlockedRooms);
    formData.append("newBlockRoom", newBlockRoom);
    formData.append("RoomConfigID", selectedRoomType);
    formData.append("CreatedBy", 1);
    formData.append("Remarks", Remarks);
    formData.append("customerName", customerName);
    formData.append("TotalRooms", totalRooms);

    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}api/dashboard/admin/hotel-blocking/${hotelId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      // reset form
      setSelectedHotel("");
      setRoomTypes([]);
      setCheckInDate("");
      setCheckOutDate("");
      setNumberOfRooms("");
      setTotalBlockedRooms("");
      setNewBlockRoom("");
      setCustomerName("");

      setRemarks("");

      console.log("Response from blocking:", response.data);
      alert("Room blocked successfully!");
    } catch (error) {
      console.error("Error confirming blocking:", error);
    }
  };
  useEffect(() => {
    if (selectedHotel && selectedRoomType) {
      console.log(
        "Auto fetching room details for:",
        selectedHotel,
        selectedRoomType,
      );
      fetchRoomDetails(selectedHotel, selectedRoomType);
    }
  }, [selectedHotel, selectedRoomType, fetchRoomDetails]);

  const selectedHotelSummary = hotels.find(
    (hotel) => Number(hotel.PropertyID) === Number(selectedHotel),
  );

  const selectedRoomSummary = roomTypes.find(
    (room) =>
      Number(room.RoomConfigID || room.HotelRoomConfigID) ===
      Number(selectedRoomType),
  );

  const handleReset = () => {
    setShowConfirmModal(false);
    setSelectedHotel("");
    setRoomTypes([]);
    setSelectedRoomType("");
    setCheckInDate("");
    setCheckOutDate("");
    setNumberOfRooms("");
    setNewBlockRoom("");
    setRemarks("");
    setCustomerName("");
    setDateError("");
    setTotalRooms(0);
    setAvailableRooms(0);
    setAvailabilityRooms([]);
    setSelectedRoomName("");
    setTotalBlockedRooms("");
    setBlockedRoomsInfo({
      count: 0,
      fromDate: "",
      toDate: "",
    });
  };

  return (
    <div className="container-fluid admin-module-page admin-hotel-blocking-page py-4">
      <div className="admin-page-header d-flex justify-content-between align-items-start flex-wrap gap-3 mb-4">
        <div>
          <span className="admin-page-kicker">Hotel Management</span>
          <h3 className="admin-page-title fw-bold mb-1">Room Blocking</h3>
          <p className="admin-page-description mb-0">
            Initiate room blocking for selected hotels and room types across specific date ranges.
          </p>
        </div>
      </div>

      <div className="row g-4">
        <div className="col-12 col-xxl-8">
          <div className="card admin-surface-card h-100">
            <div className="card-header admin-surface-header">
              <div className="d-flex flex-column flex-md-row justify-content-between gap-2 align-items-md-center">
                <div>
                  <h5 className="card-title mb-1">Blocking Details</h5>
                </div>
              </div>
            </div>

            <div className="card-body admin-surface-body">
              <form onSubmit={handleSubmit} className="row g-3">
                <div className="col-lg-6">
                  <label htmlFor="hotelSelect" className="form-label fw-semibold">
                    Hotel Name
                  </label>
                  <select
                    className="form-select"
                    id="hotelSelect"
                    value={selectedHotel}
                    onChange={handleHotelChange}
                    required
                  >
                    <option value="">Select Hotel</option>
                    {hotels &&
                      hotels.length > 0 &&
                      hotels.map((hotel) => (
                        <option key={hotel.PropertyID} value={hotel.PropertyID}>
                          {hotel.UnitName}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-lg-6">
                  <label htmlFor="roomSelect" className="form-label fw-semibold">
                    Room Type
                  </label>
                  <select
                    className="form-select"
                    id="roomSelect"
                    value={selectedRoomType || ""}
                    onChange={handleRoomTypeChange}
                    required
                  >
                    <option value="">Select Room Type</option>
                    {roomTypes &&
                      roomTypes
                        .filter((room) => room.Status === 1)
                        .map((room) => (
                          <option
                            key={room.RoomConfigID || room.HotelRoomConfigID}
                            value={room.RoomConfigID || room.HotelRoomConfigID}
                          >
                            {room.RoomType}
                          </option>
                        ))}
                  </select>
                </div>

                <div className="col-md-4">
                  <label htmlFor="fromDate" className="form-label fw-semibold">
                    Block From
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="fromDate"
                    value={checkInDate}
                    onChange={handleCheckInDateChange}
                    max={checkOutDate || undefined}
                    required
                  />
                </div>

                <div className="col-md-4">
                  <label htmlFor="toDate" className="form-label fw-semibold">
                    Block To
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="toDate"
                    value={checkOutDate}
                    onChange={handleCheckOutDateChange}
                    min={checkInDate || todayStr}
                    required
                  />
                </div>

                <div className="col-md-4">
                  <label htmlFor="totalRooms" className="form-label fw-semibold">
                    Total Rooms
                  </label>
                  <input
                    type="number"
                    className="form-control bg-light"
                    id="totalRooms"
                    value={totalRooms}
                    min="1"
                    required
                    readOnly
                  />
                </div>

                <div className="col-md-4">
                  <label htmlFor="blockRooms" className="form-label fw-semibold">
                    Total Blocked Rooms
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="blockRooms"
                    min={newBlockRoom}
                    placeholder="Enter total blocked rooms"
                    max={totalRooms}
                    value={totalBlockedRooms}
                    onChange={(e) => setTotalBlockedRooms(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-4">
                  <label htmlFor="newBlockRoom" className="form-label fw-semibold">
                    Newly Blocked Rooms
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="newBlockRoom"
                    min="1"
                    placeholder="Enter newly blocked rooms"
                    max={availableRooms}
                    value={newBlockRoom}
                    onChange={(e) => setNewBlockRoom(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-4">
                  <label htmlFor="customerName" className="form-label fw-semibold">
                    Customer Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="customerName"
                    placeholder="Enter customer name"
                    value={customerName}
                    onChange={(e) => setCustomerName(e.target.value)}
                  />
                </div>

                <div className="col-12">
                  <label htmlFor="remarks" className="form-label fw-semibold">
                    Remarks
                  </label>
                  <textarea
                    className="form-control"
                    id="remarks"
                    rows="3"
                    placeholder="Enter remarks"
                    value={Remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    required
                  ></textarea>
                </div>

                {dateError && (
                  <div className="col-12">
                    <div className="alert alert-danger mb-0 py-2" role="alert" aria-live="polite">
                      {dateError}
                    </div>
                  </div>
                )}

                <div className="col-12">
                  <div className="d-flex flex-column flex-sm-row justify-content-end gap-2 admin-form-actions">
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={handleReset}
                    >
                      Reset
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Block Room
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="col-12 col-xxl-4">
          <div className="card admin-surface-card h-100">
            <div className="card-header admin-surface-header">
              <h5 className="card-title mb-0">Selection Summary</h5>
            </div>
            <div className="card-body admin-surface-body">
              <div className="d-grid gap-3">
                <div className="admin-detail-pill">
                  <div className="small text-muted mb-1">Hotel</div>
                  <div className="fw-semibold">{selectedHotelSummary?.UnitName || "Select a hotel"}</div>
                </div>
                <div className="admin-detail-pill">
                  <div className="small text-muted mb-1">Room Type</div>
                  <div className="fw-semibold">{selectedRoomSummary?.RoomType || selectedRoomName || "Select a room type"}</div>
                </div>
                <div className="admin-detail-pill">
                  <div className="small text-muted mb-1">Blocked Duration</div>
                  <div className="fw-semibold">
                    {blockedDays === "--"
                      ? "--"
                      : `${blockedDays} ${blockedDays === 1 ? "Day" : "Days"}`}
                  </div>
                </div>
                <div className="row g-3">
                  <div className="col-6">
                    <div className="admin-detail-pill h-100">
                      <div className="small text-muted mb-1">Total Rooms</div>
                      <div className="fw-semibold fs-5">{totalRooms || 0}</div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="admin-detail-pill h-100">
                      <div className="small text-muted mb-1">Available Rooms</div>
                      <div className="fw-semibold fs-5">{availableRooms || 0}</div>
                    </div>
                  </div>
                </div>
                <div className="admin-detail-pill">
                  <div className="small text-muted mb-1">Blocked Rooms</div>
                  <div className="fw-semibold">
                    {blockedRoomsInfo.count > 0
                      ? `Previously blocked: ${blockedRoomsInfo.count}`
                      : "No previous blocks"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade ${showConfirmModal ? "show" : ""} admin-modal`}
        style={{ display: showConfirmModal ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="confirmModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <div>
                <h5 className="modal-title mb-0" id="confirmModalLabel">
                  Confirm Room Blocking
                </h5>
                <div className="text-muted small">
                  Review the details before applying the block.
                </div>
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowConfirmModal(false)}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="admin-detail-pill h-100">
                    <div className="small text-muted mb-1">Hotel</div>
                    <div className="fw-semibold">{selectedHotelSummary?.UnitName || "--"}</div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="admin-detail-pill h-100">
                    <div className="small text-muted mb-1">Room Type</div>
                    <div className="fw-semibold">{selectedRoomSummary?.RoomType || selectedRoomName || "Select a room type"}</div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="admin-detail-pill h-100">
                    <div className="small text-muted mb-1">Newly Blocked Rooms</div>
                    <div className="fw-semibold">{newBlockRoom}</div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="admin-detail-pill h-100">
                    <div className="small text-muted mb-1">
                      Total Blocked Rooms
                    </div>
                    <div className="fw-semibold">
                      {totalBlockedRooms || "--"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="admin-detail-pill h-100">
                    <div className="small text-muted mb-1">Blocked Duration</div>
                    <div className="fw-semibold">
                      {blockedDays === "--"
                        ? "--"
                        : `${blockedDays} ${blockedDays === 1 ? "Day" : "Days"}`}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="admin-detail-pill h-100">
                    <div className="small text-muted mb-1">Customer Name</div>
                    <div className="fw-semibold">{customerName || "--"}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowConfirmModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={confirmBlocking}
              >
                Confirm Blocking
              </button>
            </div>
          </div>
        </div>
      </div>

      {showConfirmModal && <div className="modal-backdrop fade show"></div>}
    </div>
  );
};

export default HotelBlockingForm;
